import React from "react";

import { SearchComponentOfType } from "@utils/search/@types/searchComponent";

import { trackSearchFilterSelected } from "@services/tracking/trackers/tools/search/searchFilterTracker";

import { Facet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facet.types";
import { FacetType } from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facetType.types";
import { FacetComponent } from "@components/Search/SearchResults/StateComponents/Facets/Facet/facet.component";
import { getComponentForFacetType } from "@components/Search/SearchResults/StateComponents/Facets/Facet/facet.rules";

type DelegatingFacetProps = {
    component: SearchComponentOfType<"FACETS">;
    facet: Facet<FacetType>;
};

const DelegatingFacet = ({ component, facet }: DelegatingFacetProps) => {
    const Component = getComponentForFacetType(facet.type);

    const sendEvent = (facetName: string, facetValue: string) => {
        trackSearchFilterSelected(facetName, facetValue, facet.index);
    };

    return (
        <FacetComponent facetName={facet.name}>
            <Component
                component={component}
                facet={facet}
                sendEvent={sendEvent}
            />
        </FacetComponent>
    );
};

export { DelegatingFacet };
